
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";
import { ElForm } from "element-ui/types/form";
import api from "@/api";
import { CreateOrEditUserCardDto } from "@/api/appService";

@Component
export default class EditCardOrder extends Vue {
  @Ref() readonly dataForm!: ElForm;

  get dialogTitle() {
    return '调整有效期';
  }

  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      await api.userCard.getForEdit({ id: this.form!.id }).then(res => {
        this.form = res.data!;
      });
    } else {
      this.form = { ...this.defaultData };
    }
    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  defaultData: CreateOrEditUserCardDto = {
    babyName: undefined,
    startDate: undefined,
    id: 0
  };

  show = false;
  form: CreateOrEditUserCardDto = { ...this.defaultData };

  async save() {
    console.log(this.form);
    this.dataForm.validate(async (valid: boolean) => {
      if (valid) {
        if (this.form!.id) {
          await api.userCard.update({ body: this.form });
        } else {
          await api.userCard.create({ body: this.form });
        }
        this.show = false;
        this.$message.success("更新成功");
        this.$emit("onSave");
      }
    });
  }

  cancel() {
    this.show = false;
  }

  roleRule = {
    name: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ]
  };
}
